import React, { useState } from "react";

function App() {
  const [data, setData] = useState("");
  const [result, setResult] = useState("");

  const ops = ["+", "-", "*", "/", "."];

  const dataHandler = (value) => {
    if (ops.includes(value) && data === "") {
      return;
    }
    if (!ops.includes(value)) {
      setResult(eval(data + value).toString());
    }
    setData((prevValue) => prevValue + value);
  };

  const calculate = () => {
    if (data === "") {
      return;
    } else {
      setData(eval(result).toString());
    }
  };
  const delFunction = () => {
    if (data === "") {
      alert("Sorry! you did not provided any data yet.");
    } else {
      setData(data.slice(0, -1));
    }
  };

  return (
    <div className="App body">
      <div className="result">
        {/* {result ? <span className="mini-result">({result})</span> : ""} */}
        {data}
      </div>
      <div className="container">
        <div className="line1">
          <button
            className="oparator expand-operator"
            onClick={() => setData("") && setResult(0)}
          >
            C
          </button>
          <button className="oparator" onClick={delFunction}>
            DEL
          </button>
          <button className="oparator" onClick={() => dataHandler("/")}>
            /
          </button>
        </div>
        <div className="line2">
          <button className="digit" onClick={() => dataHandler("7")}>
            7
          </button>
          <button className="digit" onClick={() => dataHandler("8")}>
            8
          </button>
          <button className="digit" onClick={() => dataHandler("9")}>
            9
          </button>
          <button className="oparator" onClick={() => dataHandler("*")}>
            X
          </button>
        </div>
        <div className="line3">
          <button className="digit" onClick={() => dataHandler("4")}>
            4
          </button>
          <button className="digit" onClick={() => dataHandler("5")}>
            5
          </button>
          <button className="digit" onClick={() => dataHandler("6")}>
            6
          </button>
          <button className="oparator" onClick={() => dataHandler("-")}>
            -
          </button>
        </div>
        <div className="line4">
          <button className="digit" onClick={() => dataHandler("1")}>
            1
          </button>
          <button className="digit" onClick={() => dataHandler("2")}>
            2
          </button>
          <button className="digit" onClick={() => dataHandler("3")}>
            3
          </button>
          <button className="oparator" onClick={() => dataHandler("+")}>
            +
          </button>
        </div>
        <div className="line5">
          <button className="digit" onClick={() => dataHandler("0")}>
            0
          </button>
          <button className="oparator" onClick={() => dataHandler(".")}>
            .
          </button>
          <button className="oparator expand-operator" onClick={calculate}>
            =
          </button>
        </div>
      </div>
      <h3 className="shadow">
        This calculator is developed by{" "}
        <a href="https://t.me/itboyshohidul">Shohidul Islam</a>{" "}
      </h3>
    </div>
  );
}

export default App;
